import BackgroundComps from "../components/BackgroundComps";

function About () {
    return (
        <BackgroundComps/>
    );
}

export default About;